{
  "enum": {
    "O5ApplicationV1Demand": {
      "HEAVY": "Heavy",
      "LIGHT": "Light",
      "MEDIUM": "Medium",
      "UNSPECIFIED": "Unspecified"
    },
    "O5ApplicationV1DiscoveryRecordType": {
      "A": "A",
      "SRV": "Srv",
      "UNSPECIFIED": "Unspecified"
    },
    "O5ApplicationV1O5Var": {
      "ADAPTER_ENDPOINT": "Adapter Endpoint",
      "UNSPECIFIED": "Unspecified"
    },
    "O5ApplicationV1RouteGroup": {
      "FALLBACK": "Fallback",
      "FIRST": "First",
      "NORMAL": "Normal",
      "UNSPECIFIED": "Unspecified"
    },
    "O5ApplicationV1RouteProtocol": {
      "GRPC": "gRPC",
      "HTTP": "HTTP",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "oneOf": {
    "O5ApplicationV1BlobstoreEnvVarFormat": {
      "s3Direct": "S3 Direct"
    },
    "O5ApplicationV1BlobstoreRefSource": {
      "application": "Application",
      "bucketName": "Bucket Name"
    },
    "O5ApplicationV1ContainerSource": {
      "image": "Image",
      "imageUrl": "Image URL"
    },
    "O5ApplicationV1DatabaseEngine": {
      "postgres": "Postgres"
    },
    "O5ApplicationV1EnvironmentVariableSpec": {
      "blobstore": "Blobstore",
      "database": "Database",
      "envMap": "Env Map",
      "fromEnv": "From Env",
      "o5": "O5",
      "secret": "Secret",
      "value": "Value"
    },
    "O5ApplicationV1TriggerMessageData": {
      "static": "Static"
    }
  }
}